import {shortLocale} from "@/i18n"

/** Do maior para o menor: a primeira unidade que cabe é a da frase. */
const UNITS: Array<[Intl.RelativeTimeFormatUnit, number]> = [
    ['year', 365 * 24 * 3600],
    ['month', 30 * 24 * 3600],
    ['week', 7 * 24 * 3600],
    ['day', 24 * 3600],
    ['hour', 3600],
    ['minute', 60]
]

/**
 * Quando algo aconteceu, como se diz: "há 2 horas", "ontem", "há 3 semanas" — no idioma da tela,
 * pelo `Intl`, sem uma frase a traduzir por unidade. Menos de um minuto é "agora".
 */
export function relativeTime(when: string | Date, now: Date = new Date()): string {
    const seconds = (new Date(when).getTime() - now.getTime()) / 1000
    const format = new Intl.RelativeTimeFormat(shortLocale(), {numeric: 'auto'})
    for (const [unit, size] of UNITS) {
        if (Math.abs(seconds) >= size) return format.format(Math.round(seconds / size), unit)
    }
    return format.format(0, 'second')
}

/** A data e a hora por extenso, no idioma da tela — o par do `relativeTime`, para quem quer o exato. */
export function exactTime(when: string | Date): string {
    return new Date(when).toLocaleString(shortLocale(), {dateStyle: 'long', timeStyle: 'short'})
}
